import styled from 'styled-components';

export const StdIconsRight = styled.div`
  grid-area: 1 / 16 / 4 / 24;
  display: flex;
  gap: 20px;
  -webkit-box-pack: end;
  justify-content: flex-end;
  -webkit-box-align: center;
  align-items: center;
  
  @media (min-width: 560px) {
    grid-column: 16 / 24;
    padding-left: 4px;
  }
  @media (min-width: 960px) {
    grid-column: 18 / 24;
    padding-left: 16px;
  }
  @media (min-width: 1280px) {
    grid-column: 18 / 24;   
  }


`;

export const BTIcon = styled.button`

border: 0px;
padding: 0px;
margin: 0px;
background: none;
cursor: pointer;
position: relative;
display: flex;
-webkit-box-align: center;
align-items: center;
width: auto;
height: 24px;
text-align: left;
font-size: 0px;
//color: rgb(255, 255, 255); //color texto menu
color: rgb(0, 30, 80); //color texto menu



&:hover, &:focus {
    color: rgb(0, 176, 240);
    outline: 0px;
    fill: rgb(0, 176, 240);
}
&:focus::before{
    content: "";
    box-sizing: border-box;
    position: absolute;
    top: 50%;
    left: 50%;
    width: calc(100% + 16px);
    height: calc(100% + 16px);
    border: 2px solid rgb(0, 176, 240);
    transform: translate3d(-50%, -50%, 0px);
    transition: width 0.3s cubic-bezier(0.14, 1.12, 0.67, 0.99) 0s;
}
&::after{
    content: "";
    box-sizing: border-box;
    position: absolute;
    top: 50%;
    left: 50%;
    min-width: max(100%, 44px);
    min-height: max(100%, 44px);
    transform: translate(-50%, -50%);
}


`;
export const DivText = styled.div`
    margin: 0px;
  
  
`;
export const TextIcon = styled.div`
    color: inherit;
    margin: unset;
    font-family: var(--font-family-text);
    font-weight: normal;
    font-size: 0.88rem;
    line-height: 150%;
    letter-spacing: calc(-0.02em + 0.02rem);
    padding-left: 5px;
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

